/** Clever brand blue, from the Instant Login button guidelines */
export const CLEVER_BLUE = '#4274F6'

/**
 * Simplified Clever "C" mark for the "Log in with Clever" button: white
 * glyph on a rounded brand-blue tile, sized like the Google icon next to it.
 */
export const CleverIcon = () => (
  <svg width={18} height={18} viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
    <rect width='18' height='18' rx='3' fill={CLEVER_BLUE} />
    <path
      d={
        'M12.3 11.55c-.62.8-1.6 1.3-2.76 1.3-2.14 0-3.74-1.68-3.74-3.85S7.4 5.15 9.54 5.15c1.1 0 2.04.45 2.66 1.18' +
        'l1.65-1.55C12.78 3.6 11.32 2.9 9.54 2.9 5.98 2.9 3.4 5.56 3.4 9s2.58 6.1 6.14 6.1c1.86 0 3.4-.76 4.46-2.03' +
        'l-1.7-1.52Z'
      }
      fill='#fff'
    />
  </svg>
)
